import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { AffiliateProgramService, EditInviteAffiliateProgramData } from '@/services/affiliate-program.service';
import { AxiosError } from 'axios';
import { AxiosErrorResponse } from '@/@types/Errors';
import { useTranslation } from 'react-i18next';

export const useEditInviteAffiliateProgram = () => {
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const { t } = useTranslation("affiliates");

  const { mutate, isPending } = useMutation({
    mutationFn: (data: EditInviteAffiliateProgramData) =>
      AffiliateProgramService.editInviteAffiliate(data),
    onSuccess: async () => {
      toast({
        variant: 'success',
        description: t('toast.affiliate_commission_updated_success'),
      });
      await queryClient.invalidateQueries({ queryKey: ['affiliate-program'] });
    },
    onError: (error: AxiosError<AxiosErrorResponse>) => {
      toast({
        variant: 'error',
        description:
          error?.response?.data?.message || t('generic_error'),
      });
    },
  });

  return {
    editInviteAffiliateProgram: mutate,
    isPending,
  };
};